/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div class="container-rel-ficha">
    <vue-html2pdf style="display: none" :show-layout="false" :float-layout="true" :enable-download="true"
      :preview-modal="false" :paginate-elements-by-height="1400" :pdf-quality="2" pdf-format="a4"
      pdf-orientation="portrait" pdf-content-width="100%" :html-to-pdf-options="htmlToPdfOptions"
      :manual-pagination="false" @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
      ref="html2PdfFichaEmergencia">
      <section slot="pdf-content">
        <div class="container-rel-ficha"
          :style="this.$store.state.auth.currentUser.user === 'agrimar' ? noBorderStyles : borderStyles">
          <div>
            <header class="header-rel-ficha">
              <div class="identify-rel-ficha">
                <div class="logo-rel-ficha">
                  <img :src="logo" />
                </div>
                <div class="identify-address-rel-ficha">
                  <p>{{ empresa.nome }}</p>
                  <p class="light-font-rel-ficha">{{ empresa.endereco }}</p>
                </div>
                <div class="idenfity-phone-rel-ficha">
                  <p>TELEFONE DE EMERGÊNCIA:</p>
                  <p>{{ ficha.contact_phone }}</p>
                </div>
              </div>

              <div class="header-title-rel-ficha">
                <h1 class="h1-rel-ficha">FICHA DE EMERGÊNCIA</h1>

                <div>
                  <p>Nome Apropriado para o Embarque</p>
                  {{ ficha.boarding_name }}
                </div>

                <p class="light-font-rel-ficha">Nome Comercial</p>
                <p class="bold-font-rel-ficha">{{ ficha.commercial_name }}</p>
              </div>

              <div class="header-table-rel-ficha">
                <table class="table-h-rel-ficha">
                  <tbody>
                    <tr>
                      <td class="bold-font-rel-ficha">Número de Risco:</td>
                      <td>{{ ficha.risk_number }}</td>
                    </tr>
                    <tr>
                      <td class="bold-font-rel-ficha">Número de ONU:</td>
                      <td>{{ ficha.onu_number }}</td>
                    </tr>
                    <tr>
                      <td class="bold-font-rel-ficha">
                        Classe ou
                        <br />Subclasse de Risco:
                      </td>
                      <td>{{ ficha.risk_of_class }}</td>
                    </tr>
                    <tr>
                      <td class="bold-font-rel-ficha">Descrição da classe ou Subclasse de risco:</td>
                      <td>{{ ficha.risk_description_of_class }}</td>
                    </tr>
                    <tr>
                      <td class="bold-font-rel-ficha">Grupo de Embalagem:</td>
                      <td>{{ ficha.packing_group }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </header>
            <section class="section-rel-ficha">
              <table>
                <tbody>
                  <tr>
                    <td class="table-col-1-rel-ficha">Aspecto:</td>
                    <td>{{ ficha.aspect }}</td>
                  </tr>
                  <!-- <tr>
            <td class="table-col-1"></td>
            <td class="right">
              <p class="info">Revisão desta FET em: 01/09/2009</p>
            </td>
          </tr>-->
                </tbody>
              </table>
            </section>
            <section class="section-rel-ficha">
              <table>
                <tbody>
                  <tr>
                    <td colspan="2">EPI de uso exclusivo da equipe de atendimento à
                      emergência:</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha"></td>
                    <td>{{ ficha.epi }}</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section class="section-rel-ficha">
              <h1 class="h1-rel-ficha">RISCOS</h1>
              <table>
                <tbody>
                  <tr>
                    <td class="table-col-1-rel-ficha">Fogo:</td>
                    <td>{{ ficha.fire }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Saúde:</td>
                    <td>{{ ficha.health }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Meio ambiente:</td>
                    <td>{{ ficha.environment }}</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section class="section-rel-ficha">
              <h1 class="h1-rel-ficha">EM CASO DE ACIDENTE</h1>
            </section>
            <section class="section-rel-ficha">
              <table>
                <tbody>
                  <tr>
                    <td class="table-col-1-rel-ficha">Vazamento:</td>
                    <td>{{ ficha.leak }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Fogo:</td>
                    <td>{{ ficha.fire_accident }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Poluição:</td>
                    <td>{{ ficha.pollution }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Envolvimento de pessoas:</td>
                    <td>{{ ficha.person_involvement }}</td>
                  </tr>
                  <tr>
                    <td class="table-col-1-rel-ficha">Informações ao médico:</td>
                    <td>{{ ficha.information_doctor }}</td>
                  </tr>
                  <tr>
                    <td>Observações:</td>
                    <td>{{ ficha.observation }}</td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </section>
    </vue-html2pdf>
    <div>
      <header class="header-rel-ficha" style="font-size: 0.7em">
        <div class="identify-rel-ficha">
          <div class="logo-rel-ficha">
            <img :src="logo" />
          </div>
          <div class="identify-address-rel-ficha">
            <p>{{ empresa.nome }}</p>
            <p class="light-font-rel-ficha">{{ empresa.endereco }}</p>
          </div>
          <div class="idenfity-phone-rel-ficha">
            <p>TELEFONE DE EMERGÊNCIA:</p>
            <p>{{ ficha.contact_phone }}</p>
          </div>
        </div>

        <div class="header-title-rel-ficha">
          <h1 class="h1-rel-ficha">FICHA DE EMERGÊNCIA</h1>

          <div>
            <p>Nome Apropriado para o Embarque</p>
            {{ ficha.boarding_name }}
          </div>

          <p class="light-font-rel-ficha">Nome Comercial</p>
          <p class="bold-font-rel-ficha">{{ ficha.commercial_name }}</p>
        </div>

        <div class="header-table-rel-ficha">
          <table class="table-h-rel-ficha">
            <tbody>
              <tr>
                <td class="bold-font-rel-ficha">Número de Risco:</td>
                <td>{{ ficha.risk_number }}</td>
              </tr>
              <tr>
                <td class="bold-font-rel-ficha">Número de ONU:</td>
                <td>{{ ficha.onu_number }}</td>
              </tr>
              <tr>
                <td class="bold-font-rel-ficha">
                  Classe ou
                  <br />Subclasse de Risco:
                </td>
                <td>{{ ficha.risk_of_class }}</td>
              </tr>
              <tr>
                <td class="bold-font-rel-ficha">Descrição da classe ou Subclasse de risco:</td>
                <td>{{ ficha.risk_description_of_class }}</td>
              </tr>
              <tr>
                <td class="bold-font-rel-ficha">Grupo de Embalagem:</td>
                <td>{{ ficha.packing_group }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </header>
      <section class="section-rel-ficha">
        <table>
          <tbody>
            <tr>
              <td class="table-col-1-rel-ficha">Aspecto:</td>
              <td>{{ ficha.aspect }}</td>
            </tr>
            <!-- <tr>
            <td class="table-col-1"></td>
            <td class="right">
              <p class="info">Revisão desta FET em: 01/09/2009</p>
            </td>
          </tr>-->
          </tbody>
        </table>
      </section>
      <section class="section-rel-ficha">
        <table>
          <tbody>
            <tr>
              <td colspan="2">EPI de uso exclusivo da equipe de atendimento à emergência:</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha"></td>
              <td>{{ ficha.epi }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="section-rel-ficha">
        <h1 class="h1-rel-ficha">RISCOS</h1>
        <table>
          <tbody>
            <tr>
              <td class="table-col-1-rel-ficha">Fogo:</td>
              <td>{{ ficha.fire }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Saúde:</td>
              <td>{{ ficha.health }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Meio ambiente:</td>
              <td>{{ ficha.environment }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="section-rel-ficha">
        <h1 class="h1-rel-ficha">EM CASO DE ACIDENTE</h1>
      </section>
      <section class="section-rel-ficha">
        <table>
          <tbody>
            <tr>
              <td class="table-col-1-rel-ficha">Vazamento:</td>
              <td>{{ ficha.leak }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Fogo:</td>
              <td>{{ ficha.fire_accident }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Poluição:</td>
              <td>{{ ficha.pollution }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Envolvimento de pessoas:</td>
              <td>{{ ficha.person_involvement }}</td>
            </tr>
            <tr>
              <td class="table-col-1-rel-ficha">Informações ao médico:</td>
              <td>{{ ficha.information_doctor }}</td>
            </tr>
            <tr>
              <td>Observações:</td>
              <td>{{ ficha.observation }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import empresaService from '@/src/services/empresa_sistema'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    Loading,
    VueHtml2pdf,
  },
  props: {
    ficha: {},
  },
  data() {
    return {
      textColor: 'blue',
      color: 'red',
      logo: '',
      isLoading: false,
      empresa: {},
      htmlToPdfOptions: {
        filename: `ficha-emergencia-${this.ficha.commercial_name}.pdf`,
        margin: [4, 4, 4, 4],
        image: {
          type: 'jpeg',
          quality: 1,
        },
        html2canvas: {
          scale: 2,
          logging: true,
          dpi: 192,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compressPDF: true,
        },
      },
      borderStyles: {
        borderLeft: `25px solid ${this.ficha.color}`,
        borderRight: `25px solid ${this.ficha.color}`,
      },
      noBorderStyles: {
        borderLeft: `50px solid white`,
        borderRight: `50px solid white`,
      },
    }
  },
  watch: {},
  created() { },
  mounted() {
    if (this.$store.state.auth.currentUser.user === 'agrimar') {
      document.querySelector(
        '.container-rel-ficha'
      ).style.borderLeft = `25px solid white`
      document.querySelector(
        '.container-rel-ficha'
      ).style.borderRight = `25px solid white`
    } else {
      document.querySelector(
        '.container-rel-ficha'
      ).style.borderLeft = `25px solid ${this.ficha.color}`
      document.querySelector(
        '.container-rel-ficha'
      ).style.borderRight = `25px solid ${this.ficha.color}`
    }

    this.getEmpresa()

    this.$root.$on('print-ficha-emergencia', () => {
      this.generateReport()
    })
  },
  computed: {},
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
        this.logo = `data:image/png;base64, ${resposta.data.empresa[0].logo}`
        this.isLoading = this.loading(this.isLoading)
      })
    },
    async generateReport() {
      await this.$refs.html2PdfFichaEmergencia.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const vue = this
      this.isLoading = true
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          vue.isLoading = false
        })
        .save()
    },
  },
}
</script>

<style>
.container-rel-ficha {
  width: 100%;
  height: 100%;
  font-size: 11.2px;
  padding: 0;
}

.bold-font-rel-ficha {
  font-weight: bold;
}

.header-rel-ficha,
.section-rel-ficha {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  text-align: center;
}

.header-rel-ficha {
  display: flex;
}

.header-rel-ficha p {
  margin: 0;
}

.header-rel-ficha h1 {
  font-size: 1.3em;
  margin: 2px 1em 0 auto;
  margin-top: 16px;
}

.h1-rel-ficha {
  font-size: 1.0em;
  margin: 2px 1em 0 auto;
}

.identify-rel-ficha {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 12px;
}

.header-table-rel-ficha {
  font-size: 10px;
}

.identify-rel-ficha,
.header-title-rel-ficha,
.header-table-rel-ficha {
  width: 33%;
  font-size: 11px;
}

.identify-rel-ficha {
  text-align: left;
}

.identify-address-rel-ficha {
  font-weight: 0.7em;
}

.idenfity-phone-rel-ficha {
  text-align: left;
  font-size: 10px;
}

.logo-rel-ficha {
  text-align: left;
  color: #bbb;
}

.logo-rel-ficha img {
  width: 150px;
  margin: 0;
}

.logo-rel-ficha p {
  text-transform: capitalize;
}

.header-title-rel-ficha div {
  margin-bottom: 5px;
  margin-top: 5px;
}

.table-h-rel-ficha {
  text-align: left;
  margin-top: 16px;
}

.table-h-rel-ficha tbody tr td:first-child {
  width: 60%;
}

.table-h-rel-ficha tbody tr td:last-child {
  text-align: right;
  font-weight: bold;
}

.info-rel-ficha {
  position: absolute;
  right: 0;
  width: fit-content;
  border: 1px solid #ccc;
  padding-right: 5px;
  font-weight: bold;
  margin: 0;
}

.section-rel-ficha table {
  margin: 0px 5px;
  text-align: left;
}

.section-rel-ficha table tr .right {
  position: relative;
  height: 1px;
}

.section-rel-ficha tr td:first-child {
  font-weight: bold;
  font-size: 0.9em;
}


/*


td {
  vertical-align: top;
} */

.table-col-1-rel-ficha {
  width: 10%;
}

@media print {
  body {
    width: 90%;
    font-size: 0.6em;
    padding: 0;
  }

  .container {
    border-left: 15px solid red;
    border-right: 15px solid red;
  }

  .header {
    border-top: 0px solid black;
    border-bottom: 0px solid black;
  }

  .section {
    border-top: none;
    border-bottom: 1px solid black;
    text-align: center;
  }

  .table-col-1 {
    width: 12%;
  }

  .identify {
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .logo img {
    width: 50px;
  }

  .table-h {
    margin-top: 50px;
    font-size: 1em;
  }

  .idenfity-phone {
    margin-top: 5px;
    font-size: 1.4em;
  }
}
</style>